import { webSocketService } from "./websocketService";
import { RoleEnum } from "../modules/shared/model";

interface ContractPaymentData {
  contractId: string;
  amount: number;
  currency: string;
  professionalName: string;
  clientName: string;
  chatId?: string;
  senderId: string;
  professional: any;
}

export class ContractNotificationService {
  /**
   * Send a new contract payment notification via WebSocket
   * Sends to all users - role checking is done on the receiving side
   */
  static async sendContractPaymentNotification(
    contractData: ContractPaymentData
  ): Promise<void> {
    try {
      // Prepare the WebSocket message
      const messageData = {
        receivers: [contractData.professional.id], // Send to contract participants
        sender: contractData.senderId, // Client who made the payment
        type: "new_contract",
        detail: {
          contractId: contractData.contractId,
          amount: contractData.amount,
          currency: contractData.currency,
          professionalName: contractData.professionalName,
          clientName: contractData.clientName,
          chatId: contractData.chatId
        },
        conversationId: contractData.chatId
      };

      console.log("Sending contract payment notification:", messageData);
      setTimeout(async () => {
        await webSocketService.sendMessage(messageData);
      }, 100);


      console.log("Contract payment notification sent successfully");
    } catch (error) {
      console.error("Failed to send contract payment notification:", error);
      // Don"t throw error as this is a notification, not critical to payment flow
    }
  }

  /**
   * Check if user is a professional (local or international)
   */
  static isProfessional(roleId: number): boolean {
    return roleId === RoleEnum.professional || roleId === RoleEnum.internationl_professional;
  }
}

export default ContractNotificationService;
